import React, { useState, useEffect, useContext } from "react";
import classes from "../../TrucksAvailable.module.css";
import { BID_STATUS, ENQUIRY_STAGE } from "../../negotiationConstants";
import {
  isMobile,
  Activity,
  currentRequestTimeStamp,
  NegotiateDateFormatter,
} from "../../../../Constants";
import { Urls } from "../../../../Urls";
import { toast } from "react-toastify";
import ReactTooltip from "react-tooltip";

import Timeline from "./Timeline/Timeline";
import GetStatus from "./GetStatus";
import useNegotiationStatusPolling from "./useNegotiationStatusPolling";
import ProfileModal from "../../../TransporterClientScreen/ProfileModal/ProfileModal";
import { checkModuleAccess } from "../../../../Utility";
import axios from "../../../../Axios";
import Loader from "../../../Loader";
import { AlertPopup } from "../../../Shared/AlertPopup/AlertPopup";
import { MyCompanyProfileContext } from "../../../../MyCompanyProfileContext";
import { useMixPanelForTracking } from "../../../../utils/TrackMixPanel";
import { UserApiContext } from "../../../UserDetailsContext/UserDetailsContext";
import useViewOnlyAccess from "../../../../hooks/useViewOnlyAccess";
import CountdownTimer from "../CountdownTimer";
import ConfirmDialog from "../../../Shared/ConfirmDialog2/ConfirmDialog";
import Modal from "../../../Shared/PopupModal/PopupModal";
import TurnOffLorriAgentModal from "../AssignLorriAgent/TurnOffLorriAgentModal";
import ExtendRoundsModal from "../AssignLorriAgent/ExtendRoundsModal";
import { getNegotiationAgentSettings } from "../../../../services/negotiation/negotiationService";
import approvalChainStyles from "./ApprovalChainSummary.module.css";

const groupApprovalMetricsByLevel = (approvalMetrics) => {
  if (!Array.isArray(approvalMetrics)) return [];
  const groups = {};
  approvalMetrics.forEach((m) => {
    const level = m.level ?? 0;
    if (!groups[level]) groups[level] = [];
    groups[level].push(m);
  });
  return Object.keys(groups)
    .map(Number)
    .sort((a, b) => a - b)
    .map((level) => ({ level, approvers: groups[level] }));
};

const formatApprovalTimestamp = (ts) => {
  const dateVal = ts?.$date || ts;
  if (!dateVal) return '';
  const d = new Date(dateVal);
  if (isNaN(d.getTime())) return '';
  return d.toLocaleString('en-IN', {
    day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit',
    timeZone: 'Asia/Kolkata',
  });
};

const Summary = ({
  enquiryTransition,
  // transporter_list,
  item,
  emailTemplate,
  // userid,
  itemdisable = false,
  isApprover = false,
  approval_type = "enquiry",
  autoPushIndent = false,
  companyProfile = {},
  approverList = [],
  //isRestricted,
  onSuccess,
  company_id,
  fetchSpotData,
  currentFilterPayload,
}) => {
  const [interestedlist, setList] = useState([]);
  const interestedlistRef = React.useRef(interestedlist);
  interestedlistRef.current = interestedlist;
  const { userDetails } = useContext(UserApiContext);
  const [rank_list, setRank_list] = useState([]);
  const [total_quotes_count, setTotal_quotes_count] = useState(0);
  const [errorInAcceptance, setErrorInAcceptance] = useState(false);
  const [acceptedRejectedData, setAcceptedRejectedData] = useState({});
  const [updatedRateList, setUpdatedRateList] = useState([]);
  // const [remark, setRemark] = useState('');
  const [show, setshow] = useState(false);
  const [remarkDisable, setremarkDisable] = useState(false);
  const [newtransporter_list, setnewtransporter_list] = useState([]);
  const [benchmark_list, setBenchmark_list] = useState([]);
  const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: '', message: null, onConfirm: () => { }, confirmText: 'Confirm', variant: 'default' });
  const [rateChangedDialog, setRateChangedDialog] = useState(false);
  const [rateChangedDialogData, setRateChangedDialogData] = useState({
    title: "Rate Has Been Updated",
    message: "The rate has been changed by the transporter. Please refresh to see the latest rates before taking action."
  });
  const [isIndentCreated, setIsIndentCreated] = useState(false);
  const [approvalMetrics, setApprovalMetrics] = useState([]);
  const [showApprovalChain, setShowApprovalChain] = useState(false);
  const [agentSettings, setAgentSettings] = useState(null);
  const [transporterNegotiations, setTransporterNegotiations] = useState([]);
  var company_name = userDetails.company_name
    ? userDetails.company_name
    : userDetails.email
      ? userDetails.email.split("@")[1].split(".")[0]
      : ""
  var company_mail = userDetails?.email;
  var user_name = userDetails?.user_name;
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const { TrackMixPanel } = useMixPanelForTracking(
    userDetails,
    companySettingData,
  );
  const { isRestricted } = useViewOnlyAccess("spot");
  const spotNegotiationAgentSettings = companySettingData?.agent_settings?.spot_negotiation_agent;
  const isSpotNegotiationAgentAllowedUser =
    spotNegotiationAgentSettings?.allowed_users?.some(
      (user) => user?.email?.toLowerCase() === company_mail?.toLowerCase(),
    ) ?? false;
  const showStatusColumn =
    spotNegotiationAgentSettings?.allowed === "yes" &&
    spotNegotiationAgentSettings?.enabled === "yes" &&
    isSpotNegotiationAgentAllowedUser;
  const isMandatoryApprovalRemark = companySettingData?.enquiry?.mandatory_approval_remark === true;
  const isNegotiateAfterNoRegret = companySettingData?.enquiry?.negotiate_after_no_regret === true;
  const isPostExpiryAcceptanceEnabled =
    companySettingData?.enquiry?.post_expiry_acceptance === true;
  const isPostExpiryAcceptanceFlow =
    item?.status?.is_expired === true && isPostExpiryAcceptanceEnabled;
  const isExpiredAcceptanceBlocked =
    item?.status?.is_expired === true && !isPostExpiryAcceptanceEnabled;
  const isEnquiryApproved =
    item?.main_status === BID_STATUS.APPROVED ||
    item?.status?.approved_status === BID_STATUS.APPROVED ||
    (interestedlist && interestedlist.some(t =>
      t.main_status === BID_STATUS.APPROVED ||
      (t.rate_list && t.rate_list.length > 0 && t.rate_list[t.rate_list.length - 1].main_status === BID_STATUS.APPROVED) ||
      (t.rate_list && t.rate_list.length > 0 && t.rate_list[t.rate_list.length - 1].bid_status === BID_STATUS.APPROVED)
    )) ||
    isIndentCreated ||
    item.indent_created === true;

  const sortedByRateForRecommendation = interestedlist
    .filter((t) => t.rate !== undefined && t.rate !== null)
    .slice()
    .sort((a, b) => parseFloat(a.rate) - parseFloat(b.rate));

  const recommendationCards = agentSettings?.agent_enabled
    ? sortedByRateForRecommendation
      .map((transporter, rankIdx) => {
        const negotiation = transporterNegotiations.find(
          (n) => n.transporter_id === transporter.transporter_id
        );
        const lastAgentCounter = [...(transporter.rate_list || [])]
          .reverse()
          .find(
            (r) =>
              r.bid_status === BID_STATUS.NEGOTIATED &&
              (r.negotiated_by || "").toLowerCase().includes("lorri agent")
          );
        const transporterAccepted =
          lastAgentCounter != null &&
          parseFloat(transporter.rate) === parseFloat(lastAgentCounter.negotiated_rate);
        if (!negotiation || !transporterAccepted) {
          return null;
        }
        const firstQuote = transporter?.rate_list?.[0]?.rate;
        const finalQuote = parseFloat(transporter.rate);
        const savingsAmount =
          firstQuote != null && finalQuote != null
            ? Number(firstQuote) - Number(finalQuote)
            : null;
        const savingsPercent =
          savingsAmount != null && Number(firstQuote) > 0
            ? (savingsAmount / Number(firstQuote)) * 100
            : null;
        return {
          transporter,
          negotiation,
          isL1: rankIdx === 0,
          firstQuote,
          finalQuote,
          savingsAmount,
          savingsPercent,
        };
      })
      .filter(Boolean)
    : [];

  useEffect(() => {
    Activity([
      {
        screen: "LoRRI Spot",
        module: "View Quotation",
        user_activity: `User has clicked on view quotation button`,
        timestamp: currentRequestTimeStamp(),
        "userEmail": userDetails?.email, "userName": userDetails?.user_name, "companyname": userDetails.company_name
          ? userDetails.company_name
          : userDetails.email
            ? userDetails.email.split("@")[1].split(".")[0]
            : ""
      },
    ]);

    TrackMixPanel({
      ModuleName: "lorri spot",
      ScreenName: "my enquiries - quotation summary",
      Data: `lane: ${item && item.lane_details?.origin && item.lane_details?.origin.location_name ? item.lane_details?.origin.location_name : ""} to ${item && item.lane_details?.destination && item.lane_details?.destination.location_name ? item.lane_details?.destination.location_name : ""}, truck type : ${item?.lane_details?.truck_types?.[0]?.label}`,
      Definition: `user viewed quotation summary modal`,
    });

    fetchSummary();
    if (showStatusColumn) {
      fetchAgentSettings();
    }
  }, []);

  const refetchAll = () => {
    fetchSummary(true);
    fetchAgentSettings();
  };

  const { transporterStatuses } = useNegotiationStatusPolling({
    truckEnquiryId: item?.truck_enquiry_id,
    enabled: showStatusColumn && !!agentSettings?.agent_enabled,
    onIdleTick: refetchAll,
    onTransition: refetchAll,
  });

  const fetchAgentSettings = () => {
    if (item && item.truck_enquiry_id) {
      getNegotiationAgentSettings(item.truck_enquiry_id, true)
        .then((data) => {
          setAgentSettings(data?.agent_settings || null);
          setTransporterNegotiations(data?.transporter_negotiations || []);
        })
        .catch((err) => {
          console.error(err);
        });
    }
  };

  const fetchSummary = (silent = false) => {
    var interested = [];
    var rate_list = [];
    if (!silent) {
      setshow(true);
    }

    if (item && item.truck_enquiry_id) {
      axios
        .get(`${Urls.spot}?field=view_quotations&truck_enquiry_id=${item.truck_enquiry_id}`)
        .then((res) => {
          const indentInfo = Array.isArray(res.data) ? res.data.find(obj => obj && obj.hasOwnProperty('indent_created')) : null;
          if (indentInfo) {
            setIsIndentCreated(indentInfo.indent_created);
            setApprovalMetrics(Array.isArray(indentInfo.approval_metrics) ? indentInfo.approval_metrics : []);
          }
          let transporterList = res.data;
          if (Array.isArray(transporterList)) {
            transporterList = transporterList.filter(t => t && t.transporter_id);
          }
          if (transporterList && transporterList.length > 0) {
            transporterList = transporterList.map((t) => {
              if (t.rate_list) {
                t.rate_list = t.rate_list.map((rateItem) => {
                  if (rateItem.status && !rateItem.bid_status) {
                    return { ...rateItem, bid_status: rateItem.status };
                  }
                  return rateItem;
                });
              }
              return t;
            });

            const transporterRateCounts = transporterList.map((t) => ({
              transporter_id: t.transporter_id || "",
              rate_list_count: t.rate_list?.length || 0,
            }));
            setTotal_quotes_count(transporterRateCounts);
            setBenchmark_list(item.benchmark_transporter_list || []);
            transporterList.forEach((transporter) => {
              rate_list.push(parseInt(transporter.rate));
              const previous = silent
                ? interestedlistRef.current.find(
                  (t) => t.transporter_id === transporter.transporter_id
                )
                : null;
              transporter.show_history = previous ? previous.show_history : false;
              transporter.remark = previous ? previous.remark : ""; // Add a "remark" property to each transporter
              if (
                transporter.rate_list &&
                transporter.rate_list.length > 0 &&
                transporter.rate_list[transporter.rate_list.length - 1]
                  .bid_status === BID_STATUS.NEGOTIATED
              ) {
                transporter.rate_list[
                  transporter.rate_list.length - 1
                ].change = true;
              }
              interested.push(transporter);
            });
            setnewtransporter_list(transporterList);
            setRank_list([...new Set(rate_list)]);
            setList(interested);
          } else {
            setList([]);
            setnewtransporter_list([]);
          }
          if (!silent) {
            setshow(false);
          }
        })
        .catch((err) => {
          console.error(err);
          if (!silent) {
            setshow(false);
          }
        });
    } else {
      setshow(false);
    }
  };

  /**
   * Handles the click event for a transporter, updating the interested list with a negotiated rate.
   *
   * @param {Object} transporter - The transporter object containing details like transporter_id.
   */
  const clickHandler = (transporter) => {
    if (isEnquiryApproved) {
      toast.info("This enquiry has already been approved.");
      return;
    }
    if (isPostExpiryAcceptanceFlow) {
      toast.info("Counter offer is not allowed for expired enquiry.");
      return;
    }
    const temp = interestedlist.map((t) =>
      t.transporter_id === transporter.transporter_id
        ? { ...t, negotiated_rate: t.rate, rate_list: [...t.rate_list, { bid_status: BID_STATUS.NEGOTIATED }] }
        : t
    );
    setList(temp);
  };

  /**
   * Edits the negotiated rate for a transporter in the new transporter list.
   *
   * @param {Object} transporter - The transporter object containing details like transporter_id.
   */
  const editnegrate = (transporter) => {
    const temp = newtransporter_list.map((t) => {
      if (t.transporter_id !== transporter.transporter_id) return t;
      const lastEntry = t.rate_list[t.rate_list.length - 1];
      const negotiated_rate = lastEntry && lastEntry.negotiated_rate ? lastEntry.negotiated_rate : t.rate;
      const rate_list = t.rate_list.map((entry, i) =>
        i === t.rate_list.length - 1 ? { ...entry, change: false } : entry
      );
      return { ...t, negotiated_rate, rate_list };
    });
    setList(temp);
  };

  /**
   * Increases the negotiated rate for a transporter by 500.
   *
   * @param {Object} transporter - The transporter object containing details like transporter_id.
   */
  const addHandler = (transporter) => {
    if (isEnquiryApproved) {
      toast.info("This enquiry has already been approved.");
      return;
    }
    const temp = interestedlist.map((t) =>
      t.transporter_id === transporter.transporter_id
        ? { ...t, negotiated_rate: parseInt(t.negotiated_rate) + 500 }
        : t
    );
    setList(temp);
  };

  /**
   * Decreases the negotiated rate for a transporter by 500, ensuring it doesn't go below 0.
   *
   * @param {Object} transporter - The transporter object containing details like transporter_id.
   */
  const substractHandler = (transporter) => {
    if (isEnquiryApproved) {
      toast.info("This enquiry has already been approved.");
      return;
    }
    const temp = interestedlist.map((t) =>
      t.transporter_id === transporter.transporter_id && parseInt(t.negotiated_rate) - 500 > 0
        ? { ...t, negotiated_rate: parseInt(t.negotiated_rate) - 500 }
        : t
    );
    setList(temp);
  };

  /**
   * Handles input change for the negotiated rate of a transporter.
   *
   * @param {Object} e - The event object from the input change.
   * @param {Object} transporter - The transporter object containing details like transporter_id.
   * @param {number} index - The index of the transporter in the list.
   */
  const inputChangeHandler = (e, transporter, index) => {
    const value = e.target.value;
    const temp = interestedlist.map((t) =>
      t.transporter_id === transporter.transporter_id
        ? { ...t, negotiated_rate: value }
        : t
    );
    setList(temp);
  };





  /**
   * Handles the input change event for the transporter's remark.
   *
   * @param {Object} e - The event object from the input change event.
   * @param {Object} transporter - The transporter object that is being updated.
   * @param {number} transporterIndex - The index of the transporter in the list.
   */
  const handleInputChange = (e, transporter, transporterIndex) => {
    transporter.remark = e.target.value;
  };

  const createIndent = (res, item, type) => {
    const current_enquiry =
      res.data.enquiry_lane_details &&
      res.data.enquiry_lane_details.filter(
        (enquiry) => enquiry.display_adhoc_id === item.display_adhoc_id,
      );
    let current_indent_transporters = [];
    if (type === BID_STATUS.APPROVED) {
      current_indent_transporters =
        current_enquiry && current_enquiry.length > 0
          ? current_enquiry[0].transporter_list.filter((transporter) => {
            if (transporter.main_status === BID_STATUS.APPROVED || (transporter.rate_list && transporter.rate_list.some(rate => rate.bid_status === BID_STATUS.APPROVED))) {
              transporter["is_shortlist"] = true;
              return transporter;
            }
          })
          : [];
    } else if (type === BID_STATUS.ACCEPTED) {
      current_indent_transporters =
        current_enquiry && current_enquiry.length > 0
          ? current_enquiry[0].transporter_list.filter((transporter) => {
            // Check if any rate in rate_list has bid_status 'accepted'
            const hasAcceptedBid = transporter.rate_list.some(
              (rate) => rate.bid_status === BID_STATUS.ACCEPTED,
            );

            if (hasAcceptedBid) {
              transporter["is_shortlist"] = true; // Mark transporter as shortlisted
              return true; // Include this transporter in the filtered list
            }

            return false; // Exclude transporter if no accepted bid
          })
          : [];
    }
    const indent = {
      truck_enquiry_id: item.truck_enquiry_id,
      indent_created: true,
    };
    if (current_indent_transporters && current_indent_transporters.length > 0) {
      if (
        companyProfile &&
        companyProfile.indent &&
        companyProfile.indent.indent_expiry &&
        companyProfile.indent.indent_auto_expiry_enable === "yes"
      ) {
        const expiryhours = companyProfile.indent.indent_expiry;
        let date = new Date();
        const expirydate = new Date();
        const hr = expirydate.getHours();
        expirydate.setHours(hr + parseInt(expiryhours));
        const day = expirydate.getDate();
        date = ("0" + expirydate.getDate()).slice(-2);
        const month = ("0" + (expirydate.getMonth() + 1)).slice(-2);
        const year = expirydate.getFullYear();
        const final_hr = ("0" + expirydate.getHours()).slice(-2);
        const min = ("0" + expirydate.getMinutes()).slice(-2);
        const sec = ("0" + expirydate.getSeconds()).slice(-2);
        const expiry_date = `${year}-${month}-${day} ${final_hr}:${min}:${sec}.000000`;
        const shortlistedWithRank = (current_indent_transporters || [])
          .filter((t) => t.is_shortlist === true)
          .map((t, idx) => ({
            ...t,
            rank: idx === 0 ? "L1" : t.rank,
          }));
        let newindents;
        if (item && item.from && item.from === "planning") {
          newindents = [
            {
              destination: item.lane_details?.destination,
              expiry_date: expiry_date,
              origin: item.lane_details?.origin,
              placement_date: item.lane_details?.due_date,
              shortlisted_transporters: shortlistedWithRank,
              truck_required: item.lane_details?.truck_required,
              truck_types: Array.isArray(item.lane_details?.truck_types)
                ? item.lane_details?.truck_types
                : [item.lane_details?.truck_types],
              display_indent_id: item.display_adhoc_id,
              capacity: item.lane_details?.capacity,
              tonnage: item.lane_details?.tonnage,
              load_id: item.load_id,
              truck_id: item.truck_id,
              from: item.from,
              plan_type: item.plan_type,
              lane: `${item.lane_details?.origin.location_name}-${item.lane_details?.destination.location_name}-${item.lane_details?.due_date}`,
            },
          ];
        } else {
          newindents = [
            {
              destination: item.lane_details?.destination,
              expiry_date: expiry_date,
              origin: item.lane_details?.origin,
              placement_date: item.lane_details?.due_date,
              shortlisted_transporters: shortlistedWithRank,
              truck_required: item.lane_details?.truck_required,
              truck_types: Array.isArray(item.lane_details?.truck_types)
                ? item.lane_details?.truck_types
                : [item.lane_details?.truck_types],
              from: "adhoc",
              display_indent_id: item.display_adhoc_id,
              capacity: item.lane_details?.capacity,
              tonnage: item.lane_details?.tonnage,
              document_details: item.lane_details?.document_details,
            },
          ];
        }
        axios
          .post(`${Urls.spot}?field=edit_enquiry_v2`, indent)
          .then((res) => {
            if (res.data?.status === false) {
              toast.info(res.data?.message || "Indent is already created");
              setshow(false);
              return;
            }
            toast.success("Indents floated successfully");
            setshow(false);
            if (onSuccess) onSuccess();
          })
          .catch((e) => {
            console.log(e);
            setshow(false);
          });
      } else {
        let newindent;
        const shortlistedWithRankNoExpiry = (current_indent_transporters || [])
          .filter((t) => t.is_shortlist === true)
          .map((t, idx) => ({
            ...t,
            rank: idx === 0 ? "L1" : t.rank,
          }));
        if (item && item.from && item.from === "planning") {
          newindent = [
            {
              destination: item.lane_details?.destination,
              origin: item.lane_details?.origin,
              placement_date: item.lane_details?.due_date,
              shortlisted_transporters: shortlistedWithRankNoExpiry,
              truck_required: item.lane_details?.truck_required,
              truck_types: Array.isArray(item.lane_details?.truck_types)
                ? item.lane_details?.truck_types
                : [item.lane_details?.truck_types],
              display_indent_id: item.display_adhoc_id,
              capacity: item.lane_details?.capacity,
              tonnage: item.lane_details?.tonnage,
              load_id: item.load_id,
              truck_id: item.truck_id,
              from: item.from,
              plan_type: item.plan_type,
              lane: `${item.lane_details?.origin.location_name}-${item.lane_details?.destination.location_name}-${item.lane_details?.due_date}`,
            },
          ];
        } else {
          newindent = [
            {
              destination: item.lane_details?.destination,
              origin: item.lane_details?.origin,
              placement_date: item.lane_details?.due_date,
              shortlisted_transporters: shortlistedWithRankNoExpiry,
              truck_required: item.lane_details?.truck_required,
              truck_types: Array.isArray(item.lane_details?.truck_types)
                ? item.lane_details?.truck_types
                : [item.lane_details?.truck_types],
              from: "adhoc",
              display_indent_id: item.display_adhoc_id,
              capacity: item.lane_details?.capacity,
              tonnage: item.lane_details?.tonnage,
              document_details: item.lane_details?.document_details,
            },
          ];
        }
        axios
          .post(`${Urls.spot}?field=edit_enquiry_v2`, indent)
          .then((res) => {
            if (res.data?.status === false) {
              toast.info(res.data?.message || "Indent is already created");
              setshow(false);
              return;
            }
            toast.success("Indents floated successfully");
            setshow(false);
            if (onSuccess) onSuccess();
          })
          .catch((e) => {
            console.log(e);
            setshow(false);
          });
      }
    }
  };
  /**
   * Handles the acceptance or rejection of a quotation.
   *
   * @param {Object} transporter - The transporter object associated with the quotation.
   * @param {string} value - The action to be performed ('accepted' or 'rejected').
   *
   * @throws {Error} Throws an error if there is an issue with API requests or other operations.
   */
  const acceptrejectHandler = (
    transporter,
    value,
    isConfirmWindowRequired = true,
  ) => {
    if (isEnquiryApproved) {
      toast.info("This enquiry has already been approved.");
      return;
    }
    const isPostExpiryAcceptanceEnabled =
      companySettingData?.enquiry?.post_expiry_acceptance === true;

    if (
      value === BID_STATUS.ACCEPTED &&
      item?.status?.is_expired === true &&
      !isPostExpiryAcceptanceEnabled
    ) {
      toast.info("Enquiry Expired");
      return;
    }
    if (isPostExpiryAcceptanceFlow && value === BID_STATUS.REJECTED) {
      toast.info("Reject is not allowed for expired enquiry.");
      return;
    }
    setAcceptedRejectedData({ transporter: transporter, value: value });

    // Mandatory remark check for non-L1 acceptance
    // Fires only on first click (isConfirmWindowRequired=true), not on confirm callback
    if (value === BID_STATUS.ACCEPTED && isConfirmWindowRequired && isMandatoryApprovalRemark) {
      const sortedByRate = interestedlist
        .filter(t => t.rate !== undefined && t.rate !== null)
        .slice()
        .sort((a, b) => parseFloat(a.rate) - parseFloat(b.rate));

      const transporterRank = sortedByRate.findIndex(
        t => t.transporter_id === transporter.transporter_id
      );

      // index 0 = L1; anything above = L2, L3, ... → remark is mandatory
      if (transporterRank > 0 && (!transporter.remark || transporter.remark.trim() === "")) {
        const rankLabel = `L${transporterRank + 1}`;
        toast.error(
          `Remark is mandatory for (${rankLabel}). Please add a remark before proceeding.`
        );
        return;
      }
    }

    if (isConfirmWindowRequired) {
      const isAccept = value === 'accepted';

      const approvalChainLevels = (() => {
        const approvers = companySettingData?.enquiry?.enquiry_approvers;
        if (!isAccept || !Array.isArray(approvers) || approvers.length === 0) return null;
        const groups = {};
        approvers.forEach((a) => {
          const level = a.level ?? 0;
          if (!groups[level]) groups[level] = [];
          groups[level].push(a.name || a.email || 'Unknown');
        });
        return Object.keys(groups)
          .map(Number)
          .sort((a, b) => a - b)
          .map((level) => ({ level, names: groups[level] }));
      })();

      setConfirmDialog({
        isOpen: true,
        title: isAccept ? (isApprover ? 'Approve Quotation?' : 'Accept Quotation?') : 'Reject Quotation?',
        message: (
          <span>
            Are you sure you want to{' '}
            <strong style={{ color: isAccept ? '#1cc88a' : '#e74a3b' }}>
              {isAccept ? (isApprover ? 'approve' : 'accept') : 'reject'}
            </strong>{' '}
            the quotation of{' '}
            <strong style={{ color: '#393185' }}>{transporter.transporter_name}</strong>?
            {approvalChainLevels && (
              <span className={approvalChainStyles.wrapper}>
                <span className={approvalChainStyles.label}>APPROVAL CHAIN</span>
                {approvalChainLevels.map(({ level, names }) => (
                  <span key={level} className={approvalChainStyles.level}>
                    <span className={approvalChainStyles.levelBadge}>L{level}</span>
                    <span className={approvalChainStyles.names}>{names.join(', ')}</span>
                  </span>
                ))}
              </span>
            )}
          </span>
        ),
        confirmText: isAccept ? (isApprover ? 'Yes, Approve' : 'Yes, Accept') : 'Yes, Reject',
        variant: isAccept ? 'success' : 'danger',
        onConfirm: () => acceptrejectHandler(transporter, value, false),
      });
      return;
    }
    Activity([
      {
        screen: "LoRRI Spot",
        module: "View Quotation",
        user_activity: `User has clicked on ${value} button`,
        timestamp: currentRequestTimeStamp(),
        "userEmail": userDetails?.email, "userName": userDetails?.user_name, "companyname": userDetails.company_name
          ? userDetails.company_name
          : userDetails.email
            ? userDetails.email.split("@")[1].split(".")[0]
            : ""
      },
    ]);
    TrackMixPanel({
      ModuleName: "lorri spot",
      ScreenName: "my enquiries - quotation summary",
      Data: `lane: ${item && item.lane_details?.origin && item.lane_details?.origin.location_name ? item.lane_details?.origin.location_name : ""} to ${item && item.lane_details?.destination && item.lane_details?.destination.location_name ? item.lane_details?.destination.location_name : ""}, truck type : ${item?.lane_details?.truck_types?.[0]?.label},
        transporter name: ${transporter?.transporter_name}, transporter id: ${transporter?.transporter_id}, transporter rate: ${transporter?.rate}`,
      Definition: `user has clicked on ${value === BID_STATUS.ACCEPTED ? (isApprover ? "approve" : "accept") : "reject"
        } enquiry button`,
    });

    setremarkDisable(true);
    let total_rates = total_quotes_count.reduce(
      (sum, t) => sum + t.rate_list_count,
      0,
    );

    const bidStatus = (value === BID_STATUS.ACCEPTED && isApprover) ? BID_STATUS.APPROVED : value;

    let payload;
    if (value === BID_STATUS.ACCEPTED) {
      if (approval_type === "bulk" && !isApprover) {
        payload = {
          truck_enquiry_id: item.truck_enquiry_id,
          transporter_id: transporter.transporter_id,
          rate: transporter.rate,
          total_quotes_count: total_rates,
          quot_type: transporter.quot_type || null,
          bid_status: bidStatus,
          approver: false,
          mode: "enquiry_level",
          remark: transporter.remark || "",
        };
      } else {
        payload = {
          truck_enquiry_id: item.truck_enquiry_id,
          transporter_id: transporter.transporter_id,
          rate: transporter.rate,
          total_quotes_count: total_rates,
          quot_type: transporter.quot_type || null,
          bid_status: bidStatus,
          approver: isApprover,
          mode: "enquiry_level",
          remark: transporter.remark || "",
        };
      }
    } else {
      payload = {
        truck_enquiry_id: item.truck_enquiry_id,
        transporter_id: transporter.transporter_id,
        rate: transporter.rate,
        total_quotes_count: total_rates,
        quot_type: transporter.quot_type || null,
        bid_status: bidStatus,
        approver: isApprover,
        mode: "enquiry_level",
        remark: transporter.remark || "",
      };
    }

    axios
      .put(
        `${Urls.spot}?edit_bid_status_v2=${value}&force_update=${!isConfirmWindowRequired}&field=logistics_enquiry`,
        payload,
      )
      .then((res) => {
        if (
          res &&
          res.data &&
          res.data.status &&
          (res.data.status === "update_failed" || res.data.status === "Failed")
        ) {
          if (
            res.data.new_updates === true ||
            res.data.new_updates === "true"
          ) {
            if (
              res.data.rate_update_status &&
              res.data.rate_update_status.length > 0
            ) {
              setUpdatedRateList(res.data.rate_update_status);
            }
            setErrorInAcceptance(true);
          } else {
            if (res.data.message === "the client has been updated the rate. Please refresh the page") {
              setRateChangedDialogData({
                title: "Rate Has Been Updated",
                message: "the client has been updated the rate. Please refresh the page",
                showConfirm: false,
                cancelText: "Close"
              });
            } else if (res.data.message === "Spot has been expired") {
              setRateChangedDialogData({
                title: "Spot Expired",
                message: "Spot has been expired",
                showConfirm: false,
                cancelText: "Close"
              });
            } else {
              setRateChangedDialogData({
                title: "Rate Has Been Updated",
                message: "The transporter has updated the rate. Please refresh the page to see the latest rate before taking any action.",
                showConfirm: true,
                confirmText: "Refresh Now",
                cancelText: "Cancel"
              });
            }
            setRateChangedDialog(true);
          }
          setshow(false);
        } else {
          if (onSuccess) onSuccess();
          if (value === BID_STATUS.ACCEPTED) {
            toast.success(
              isApprover
                ? `Quotation Approved for ${transporter.transporter_name}`
                : `Quotation Accepted for ${transporter.transporter_name}`,
            );
            axios
              .get(`${Urls.spot}?field=get_enquiry&truck_enquiry_id=${item.truck_enquiry_id}`)
              .then((res) => {
                const enquiryData = res.data.enquiry_lane_details ? res.data.enquiry_lane_details[0] : res.data;
                if (
                  enquiryData &&
                  autoPushIndent &&
                  autoPushIndent === true &&
                  (!enquiryTransition || enquiryTransition === false) &&
                  !isApprover
                ) {
                  createIndent({ data: { enquiry_lane_details: [enquiryData] } }, item, BID_STATUS.ACCEPTED);
                }
                setshow(false);


                if (
                  enquiryData &&
                  autoPushIndent &&
                  autoPushIndent === true &&
                  (enquiryTransition ||
                    enquiryTransition === true ||
                    isApprover === true)
                ) {
                  createIndent({ data: { enquiry_lane_details: [enquiryData] } }, item, BID_STATUS.APPROVED);
                }
              })
              .catch((err) => {
                setshow(false);
                console.log(err);
              });
          } else {
            toast.error(
              `Quotation Rejected for ${transporter.transporter_name}`,
            );
            axios
              .get(`${Urls.spot}?field=get_enquiry&truck_enquiry_id=${item.truck_enquiry_id}`)
              .then((res) => {
                const enquiryData = res.data.enquiry_lane_details ? res.data.enquiry_lane_details[0] : res.data;
                setshow(false);

              })
              .catch((err) => {
                setshow(false);
                console.log(err);
              });
          }

          const temp = interestedlist.map((trans) => {
            if (trans.transporter_id !== transporter.transporter_id) return trans;
            const rate_list = trans.rate_list.map((entry, i) =>
              i === trans.rate_list.length - 1 ? { ...entry, bid_status: bidStatus } : entry
            );
            return { ...trans, rate_list };
          });
          setList(temp);
          fetchSummary();
        }
      })
      .catch((err) => console.log(err))
      .finally(() => {
        setshow(false);
      });
  };

  /**
   * Handles the submission of a negotiated rate by a transporter. This function
   * manages user activity logging, event tracking with Mixpanel, rate validation,
   * server updates, and sending notifications via email.
   *
   * @param {Object} transporter - The transporter object containing negotiation details.
   * @param {string} transporter.transporter_name - The name of the transporter.
   * @param {number} transporter.rate - The initial rate provided by the transporter.
   * @param {number} transporter.negotiated_rate - The rate proposed by the company for negotiation.
   * @param {string} [transporter.remark] - Optional remark for the negotiation.
   * @returns {void}
   */
  const submitNegotiatedRate = (transporter) => {
    if (isEnquiryApproved) {
      toast.info("This enquiry has already been approved.");
      return;
    }


    // Log user activity
    Activity([
      {
        screen: "LoRRI Spot",
        module: "View Quotation",
        user_activity: `User has clicked on negitiate button`,
        timestamp: currentRequestTimeStamp(),
        "userEmail": userDetails?.email, "userName": userDetails?.user_name, "companyname": userDetails.company_name
          ? userDetails.company_name
          : userDetails.email
            ? userDetails.email.split("@")[1].split(".")[0]
            : ""
      },
    ]);

    TrackMixPanel({
      ModuleName: "lorri spot",
      ScreenName: "my enquiries - quotation summary",
      Data: `lane: ${item && item.lane_details?.origin && item.lane_details?.origin.location_name ? item.lane_details?.origin.location_name : ""} to ${item && item.lane_details?.destination && item.lane_details?.destination.location_name ? item.lane_details?.destination.location_name : ""}, truck type : ${item?.lane_details?.truck_types?.[0]?.label},
        transporter name: ${transporter?.transporter_name}, transporter id: ${transporter?.transporter_id}, transporter rate: ${transporter?.rate}, negotiated rate: ${transporter.negotiated_rate}`,
      Definition: `user clicked on the submit negotiate rate button on an enquiry`,
    });

    // Validate the negotiated rate
    if (parseInt(transporter.negotiated_rate) === parseInt(transporter.rate)) {
      toast.info("Rate and Counter Offer cannot be the same");
    } else if (
      transporter.negotiated_rate === "" ||
      transporter.negotiated_rate === undefined ||
      parseInt(transporter.negotiated_rate) < 0 ||
      transporter.negotiated_rate === null ||
      parseInt(transporter.negotiated_rate) === 0
    ) {
      toast.info("Rate and Counter Offer cannot be empty or 0");
    } else {
      let total_rates = total_quotes_count.reduce(
        (sum, t) => sum + t.rate_list_count,
        0,
      );
      var payload = {
        truck_enquiry_id: item.truck_enquiry_id,
        transporter_id: transporter.transporter_id,
        rate: transporter.rate,
        total_quotes_count: total_rates,
        quot_type: transporter.quot_type || null,
        bid_status: BID_STATUS.NEGOTIATED,
        negotiated_rate: transporter.negotiated_rate,
        remark: transporter.remark || "",
        approver: isApprover,
        mode: "enquiry_level",
      };
      // console.log(payload, '628')
      setshow(true);

      // Update server with negotiated rate
      axios
        .put(
          `${Urls.spot}?edit_bid_status_v2=negotiated&field=logistics_enquiry`,
          payload,
        )
        .then((res) => {
          if (
            res &&
            res.data &&
            res.data.status &&
            (res.data.status === "update_failed" || res.data.status === "Failed")
          ) {
            setshow(false);
            if (res.data.message === "the client has been updated the rate. Please refresh the page") {
              setRateChangedDialogData({
                title: "Rate Has Been Updated",
                message: "the client has been updated the rate. Please refresh the page",
                showConfirm: false,
                cancelText: "Close"
              });
            } else if (res.data.message === "Spot has been expired") {
              setRateChangedDialogData({
                title: "Spot Expired",
                message: "Spot has been expired",
                showConfirm: false,
                cancelText: "Close"
              });
            } else {
              setRateChangedDialogData({
                title: "Rate Has Been Updated",
                message: "The transporter has updated the rate. Please refresh the page to see the latest rate before taking any action.",
                showConfirm: true,
                confirmText: "Refresh Now",
                cancelText: "Cancel"
              });
            }
            setRateChangedDialog(true);
          } else {
            const temp = interestedlist.map((trans) => {
              if (trans.transporter_id !== transporter.transporter_id) return trans;
              const rate_list = trans.rate_list.map((entry, i) =>
                i === trans.rate_list.length - 1
                  ? {
                    bid_status: BID_STATUS.NEGOTIATED,
                    negotiated_rate: transporter.negotiated_rate,
                    negotiated_at: new Date(),
                    rate: transporter.rate,
                    rate_by: "company",
                    change: true,
                    negotiated_by: userDetails?.user_name,
                    negotiated_by_email: userDetails?.email,
                    remark: transporter.remark,
                  }
                  : entry
              );
              return { ...trans, rate_list };
            });
            setList(temp);
            toast.success(
              `Counter offer quote submitted to ${transporter.transporter_name}`,
            );
            if (onSuccess) onSuccess();

            // Fetch updated transporter list
            fetchSummary();
          }
        })
        .catch((err) => {
          console.log(err);
          setshow(false);
        });
    }
  };

  /**
   * Cancels a negotiated rate for a transporter. This function updates the list of
   * interested transporters by either marking the rate as changed or removing the
   * negotiated rate from the list based on the current state.
   *
   * @param {Object} transporter - The transporter object whose negotiated rate is to be canceled.
   * @param {string} transporter.transporter_id - The ID of the transporter.
   * @param {Array<Object>} transporter.rate_list - The list of rates for the transporter.
   * @returns {void}
   */
  const cancelnegotiate = (transporter) => {
    if (isEnquiryApproved) {
      toast.info("This enquiry has already been approved.");
      return;
    }
    // Check if the transporter has a negotiated rate and it is not zero
    const lastEntry = transporter.rate_list?.[transporter.rate_list.length - 1];
    if (lastEntry?.negotiated_rate) {
      // Mark the rate as changed
      const temp = interestedlist.map((trans) => {
        if (trans.transporter_id !== transporter.transporter_id) return trans;
        const rate_list = trans.rate_list.map((entry, i) =>
          i === trans.rate_list.length - 1 ? { ...entry, change: true } : entry
        );
        return { ...trans, rate_list };
      });
      setList(temp);
    } else {
      // Remove the negotiated rate entry from the list
      const temp = interestedlist.map((trans) => {
        if (trans.transporter_id !== transporter.transporter_id) return trans;
        return { ...trans, rate_list: trans.rate_list.slice(0, -1) };
      });
      setList(temp);
    }
  };

  /**
   * Toggles the visibility of the history for a specific transporter in the interested list.
   *
   * @param {Object} history_for_transporter - The transporter object for which history visibility is to be toggled.
   * @param {string} history_for_transporter.transporter_id - The unique identifier of the transporter whose history is being toggled.
   */
  const showHistory = (history_for_transporter) => {
    const transporterList = interestedlist.map((transporter) =>
      transporter.transporter_id === history_for_transporter.transporter_id
        ? { ...transporter, show_history: !transporter.show_history }
        : transporter
    );
    setList(transporterList);
  };

  /**
   * Retrieves the lowest bid from the list of interested transporters.
   *
   * @returns {string|number} The lowest bid from the interested list, or `'--'` if no rates are available.
   */
  const getLowestBid = () => {
    const hasRate = interestedlist.filter(
      (l) => l.rate !== undefined && l.rate !== null,
    );
    if (hasRate.length === 0) {
      return "--";
    }

    const lowestRate = Math.min(
      ...hasRate.map((item) => parseFloat(item.rate)),
    );
    return lowestRate;
  };
  const handleClose = () => {
    setErrorInAcceptance(false);
  };

  // Shared props for every <GetStatus /> instance below (transporter/index vary per row) —
  // kept as one object so the two render call sites (mobile + desktop) can't drift apart.
  const getStatusSharedProps = {
    approval_type,
    isNegotiateAfterNoRegret,
    isRestricted,
    isEnquiryApproved,
    itemdisable,
    isExpiredAcceptanceBlocked,
    item,
    isIndentCreated,
    acceptrejectHandler,
    isApprover,
    companySettingData,
    clickHandler,
    isMandatoryApprovalRemark,
    remarkDisable,
    handleInputChange,
    interestedlist,
    isPostExpiryAcceptanceFlow,
    editnegrate,
    inputChangeHandler,
    addHandler,
    substractHandler,
    submitNegotiatedRate,
    cancelnegotiate,
  };

  return (
    <>
      <Loader show={show} />

      <ConfirmDialog
        isOpen={confirmDialog.isOpen}
        onClose={() => setConfirmDialog(prev => ({ ...prev, isOpen: false }))}
        onConfirm={confirmDialog.onConfirm}
        title={confirmDialog.title}
        message={confirmDialog.message}
        confirmText={confirmDialog.confirmText}
        variant={confirmDialog.variant}
      />

      <ConfirmDialog
        isOpen={rateChangedDialog}
        onClose={() => setRateChangedDialog(false)}
        onConfirm={() => {
          setRateChangedDialog(false);
          fetchSummary();
        }}
        title={rateChangedDialogData.title}
        message={
          <span>
            <i className="fa fa-exclamation-triangle" style={{ color: '#e74a3b', marginRight: '8px' }} />
            {rateChangedDialogData.message}
          </span>
        }
        confirmText={rateChangedDialogData.confirmText || "Refresh Now"}
        cancelText={rateChangedDialogData.cancelText || "Cancel"}
        showConfirm={rateChangedDialogData.showConfirm}
        variant="warning"
        closeOnEscape={false}
      />

      {newtransporter_list &&
        newtransporter_list !== undefined &&
        newtransporter_list.length > 0 ? (
        <>
          {agentSettings?.agent_enabled && (
            <div className={classes["summary-agent-banner"]}>
              {agentSettings?.enquiry_stage === ENQUIRY_STAGE.READY_FOR_HANDOFF && (
                <>
                  <span className={classes["summary-agent-banner-dot"]} />
                  <span className={classes["summary-agent-banner-status"]}>
                    Ready for handoff
                  </span>
                  <span className={classes["summary-agent-banner-divider"]}>|</span>
                </>
              )}
              <span className={classes["summary-agent-banner-label"]}>
                AGENT TARGET
              </span>
              <span className={classes["summary-agent-banner-value"]}>
                ₹{Number(agentSettings?.target_rate || 0).toLocaleString("en-IN")}
              </span>
            </div>
          )}
          <div className="row" style={{ marginBottom: "16px", alignItems: "stretch" }}>
            <div className="col-md-7">
              <div style={{ marginBottom: "12px" }}>
                <CountdownTimer
                  expiry_date={item.expiry_date}
                  isExpired={item.status?.is_expired}
                  isDelete={item.status?.is_deleted}
                  ApprovedStatus={item.status?.approved_status}
                  enquiry_closed={item.status?.enquiry_closed}
                  ScreenName="my enquiries - quotation summary"
                />
              </div>
              <div className={classes["summary-stat-row"]}>
                {/* Responses Card */}
                <div className={`${classes["summary-stat-card"]} ${classes["summary-stat-card-purple"]}`}>
                  <div className={classes["summary-stat-card-header"]}>
                    <span className={`${classes["summary-stat-icon"]} ${classes["summary-stat-icon-purple"]}`}>
                      <i className="fa fa-users" />
                    </span>
                    <span className={classes["summary-stat-label"]}>Responses</span>
                  </div>
                  <div className={classes["summary-stat-value-purple"]}>{interestedlist.length}</div>
                </div>
                {/* L1 Rate Card */}
                <div className={`${classes["summary-stat-card"]} ${classes["summary-stat-card-green"]}`}>
                  <div className={classes["summary-stat-card-header"]}>
                    <span className={`${classes["summary-stat-icon"]} ${classes["summary-stat-icon-green"]}`}>
                      <i className="fa fa-trophy" />
                    </span>
                    <span className={classes["summary-stat-label"]}>Lowest Quote (L1)</span>
                  </div>
                  <div className={classes["summary-stat-value-green"]}>
                    {interestedlist && interestedlist.length > 0 ? (getLowestBid() !== "--" ? Number(getLowestBid()).toLocaleString('en-IN') : "--") : "--"}
                  </div>
                </div>
                {/* L1 Transporter Card */}
                <div className={`${classes["summary-stat-card"]} ${classes["summary-stat-card-blue"]}`}>
                  <div className={classes["summary-stat-card-header"]}>
                    <span className={`${classes["summary-stat-icon"]} ${classes["summary-stat-icon-blue"]}`}>
                      <i className="fa fa-truck" />
                    </span>
                    <span className={classes["summary-stat-label"]}>L1 Transporter</span>
                  </div>
                  <div className={classes["summary-stat-value-blue"]}>
                    {interestedlist.length > 0 ? (() => {
                      const transporterWithLowestRate = interestedlist.reduce((minTransporter, currentTransporter) => {
                        const currentRate = parseFloat(currentTransporter.rate);
                        const minRate = parseFloat(minTransporter.rate);
                        if (!isNaN(currentRate) && (isNaN(minRate) || currentRate < minRate)) {
                          return currentTransporter;
                        }
                        return minTransporter;
                      }, "--");
                      return (
                        <ProfileModal
                          buttonClass={`btn-link p-0 m-0`}
                          style={{ fontSize: '13px', fontWeight: '700' }}
                          transporter_list={interestedlist}
                          transporter_name={transporterWithLowestRate.transporter_name}
                          transporter_id={transporterWithLowestRate.transporter_id}
                          screenName={"LoRRI Adhoc"}
                          moduleName={"My Enquiries"}
                        />
                      );
                    })() : "--"}
                  </div>
                </div>
              </div>
              {isIndentCreated || item.indent_created === true ? (
                <div className={`${classes["summary-status-banner"]} ${classes["summary-status-banner-success"]}`}>
                  <i className="fa fa-check-circle" />
                  Indent has been created for this enquiry
                </div>
              ) : item.status?.is_expired === true ? (
                <div className={`${classes["summary-status-banner"]} ${classes["summary-status-banner-danger"]}`}>
                  <i className="fa fa-clock-o" />
                  This enquiry is expired
                </div>
              ) : item.status?.enquiry_closed === true ? (
                <div className={`${classes["summary-status-banner"]} ${classes["summary-status-banner-warning"]}`}>
                  <i className="fa fa-exclamation-triangle" />
                  This enquiry is closed
                </div>
              ) : null}
              {(() => {
                const configuredApprovers = companySettingData?.enquiry?.enquiry_approvers;
                const displayApprovalMetrics = approvalMetrics.length > 0
                  ? approvalMetrics
                  : (Array.isArray(configuredApprovers) ? configuredApprovers.map((a) => ({
                    name: a.name,
                    email: a.email,
                    level: a.level ?? 0,
                    status: 'pending',
                  })) : []);
                if (displayApprovalMetrics.length === 0) return null;
                return (
                <div className={approvalChainStyles.statusSection}>
                  <button
                    type="button"
                    className={approvalChainStyles.statusToggle}
                    onClick={() => setShowApprovalChain((prev) => !prev)}
                  >
                    <i className={`fa fa-chevron-${showApprovalChain ? 'down' : 'right'}`} />
                    APPROVAL CHAIN
                  </button>
                  {showApprovalChain && (
                    <div className={approvalChainStyles.statusLevels}>
                      {groupApprovalMetricsByLevel(displayApprovalMetrics).map(({ level, approvers }) => (
                        <div key={`approval-level-${level}`} className={approvalChainStyles.statusLevelGroup}>
                          <span className={approvalChainStyles.statusLevelLabel}>L{level}</span>
                          {approvers.map((approver, ai) => {
                            const displayName = approver.name || approver.email || 'Unknown';
                            const initial = displayName.trim().charAt(0).toUpperCase() || '?';
                            return (
                              <div key={`${level}-${approver.email || ai}`} className={approvalChainStyles.statusNameRow}>
                                <span className={approvalChainStyles.statusAvatar}>{initial}</span>
                                <div>
                                  <div className={approvalChainStyles.statusName}>{displayName}</div>
                                  {approver.status === 'approved' && approver.transporter_name ? (
                                    <div className={approvalChainStyles.statusApproved}>
                                      Approved: {approver.transporter_name}
                                      {approver.status_updated_at ? ` · ${formatApprovalTimestamp(approver.status_updated_at)}` : ''}
                                    </div>
                                  ) : (
                                    <div className={approvalChainStyles.statusPending}>Pending</div>
                                  )}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                );
              })()}
            </div>
            {isMobile() ? null : (
              <div className="col-md-5">
                <div className={classes["summary-legend-panel"]}>
                  <div className={classes["summary-legend-title"]}>
                    <i className="fa fa-info-circle" style={{ marginRight: '5px', opacity: 0.6 }} />Legend
                  </div>
                  <div className={classes["summary-legend-grid"]}>
                    {[
                      { icon: !isApprover ? "fa fa-check" : "fa fa-thumbs-up", color: '#1cc88a', bg: '#e6faf3', label: !isApprover ? (approval_type === "bulk" ? "Accept" : "Request Approval") : "Approve" },
                      { icon: "fa fa-times", color: '#e74a3b', bg: '#fdecea', label: "Reject" },
                      { icon: "fa fa-tag", color: '#4e73df', bg: '#eaeffc', label: "Negotiated" },
                      { icon: null, isSymbol: true, color: '#4e73df', bg: '#eaeffc', label: "Counter Offer" },
                      { icon: "fa fa-history", color: '#36b9cc', bg: '#e3f8fc', label: "History" },
                      { icon: "fa fa-dot-circle-o", color: '#1cc88a', bg: '#e6faf3', label: "Final Negotiated" },
                    ].map((item2, i) => (
                      <div key={i} className={classes["summary-legend-item"]}>
                        <span className={classes["summary-legend-icon"]} style={{ background: item2.bg }}>
                          {item2.isSymbol
                            ? <span style={{ fontSize: '9px', fontWeight: 'bold', color: item2.color }}>{companySettingData?.default_currency?.default_currency?.symbol ?? <i className="fa fa-inr" />}</span>
                            : <i className={item2.icon} style={{ fontSize: '9px', color: item2.color }} />
                          }
                        </span>
                        {item2.label}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
          <div style={{ maxHeight: "50vh", overflowY: "auto" }}>
            <AlertPopup
              show={errorInAcceptance}
              isClosable={true}
              onClose={handleClose}
              withHeader={true}
              headerTitle="You might have received New Quotes"
              closeOnEscape={false}
              contentClassName="p-5"
              closeButtonClassName="btn btn-sm text-muted"
              isCancelButtonRequired={true}
              cancelButtonContent="Proceed with Existing"
              acceptButtonContent="Review"
              isAcceptButtonRequired={true}
              onAcceptClick={() => {
                fetchSummary();
                setErrorInAcceptance(false);
              }}
              onCancelClick={() => {
                acceptrejectHandler(
                  acceptedRejectedData.transporter,
                  acceptedRejectedData.value,
                  false,
                );
                setErrorInAcceptance(false);
              }}
            >
              <div style={{ width: "92%" }}>
                Please Click on <b>Review</b> to check new quotes or{" "}
                <b>Proceed with Existing</b>.
              </div>
            </AlertPopup>
            {isMobile() ? (
              <div>
                {interestedlist && interestedlist.length > 0
                  ? interestedlist.map((tl, index) => {
                    return (
                      <div key={tl.transporter_id || index} className={classes["mob-transporter"]}>
                        <div>
                          <b>Rank: </b>
                          {rank_list && rank_list.length > 0
                            ? rank_list.map((rank, i) => {
                              if (rank === parseInt(tl.rate)) {
                                return <span>{i + 1}</span>;
                              }
                            })
                            : null}
                        </div>
                        <div>
                          <b>Transporter Name</b>
                          {tl.transporter_name ? (
                            // <a href={`/tpmp/${encryptor(tl.transporter_id, true)}`} target="_blank" rel="noopener noreferrer">{Uppercase(tl.transporter_name)}</a>
                            <ProfileModal
                              transporter_id={tl.transporter_id}
                              transporter_name={tl.transporter_name}
                              screenName={"LoRRI Adhoc"}
                              moduleName={"My Enquiries"}
                            />
                          ) : (
                            item?.benchmark_transporter_list?.map((val) => {
                              if (val.transporter_id === tl.transporter_id) {
                                return (
                                  <ProfileModal
                                    transporter_list={interestedlist}
                                    transporter_id={val.transporter_id}
                                    transporter_name={val.transporter_name}
                                    screenName={"LoRRI Adhoc"}
                                    moduleName={"My Enquiries"}
                                  />
                                );
                                // <a href={`/tpmp/${encryptor(tl.transporter_id, true)}`} target="_blank" rel="noopener noreferrer">{Uppercase(val.transporter_name)}</a>
                              }
                            })
                          )}
                        </div>
                        <div>
                          <b>Rate: </b>
                          {tl.rate ? Number(tl.rate).toLocaleString('en-IN') : tl.rate}
                          {(tl.quot_type === "counter_offer_quote" ||
                            tl.quot_type === "quote_after_rejection") &&
                            tl.rate_list[tl.rate_list.length - 1].bid_status !==
                            BID_STATUS.ACCEPTED ? (
                            <i className={`fa fa-tag`} />
                          ) : null}
                        </div>
                        <div>
                          <b>Timestamp: </b>
                          {tl.rate_submission_date
                            ? NegotiateDateFormatter(tl.rate_submission_date)
                            : null}
                        </div>
                        <div>
                          <b>Interest Status: </b>
                          {tl.interest_data && tl.interest_data.length > 0
                            ? tl.interest_data[tl.interest_data.length - 1]
                              .interest_status === "not_interested"
                              ? "Not Interested"
                              : tl.interest_data[tl.interest_data.length - 1]
                                .interest_status === "Interested"
                                ? "Interested"
                                : tl.interest_data[
                                  tl.interest_data.length - 1
                                ].interest_status === "not_operating"
                                  ? "Do Not Operate"
                                  : "Interested"
                            : "Interested"}
                        </div>
                        <div>
                          <div>
                            {tl.rate_list && tl.rate_list.length > 0 ? (
                              <div style={{ margin: "0" }}>
                                <div>
                                  <b>Status: </b>
                                </div>
                                <GetStatus transporter={tl} index={index} {...getStatusSharedProps} />
                              </div>
                            ) : (
                              "-"
                            )}
                          </div>
                          <div
                            style={{ width: isMobile() ? "250px" : "600px" }}
                          >
                            <div style={{ display: "flex", margin: "3% 0" }}>
                              <div>
                                <b>History:</b>
                              </div>
                              <button
                                className={`btn btn-sm btn-info`}
                                style={{
                                  margin: isMobile() ? "" : "1% 5%",
                                  padding: isMobile() ? "0 1%" : "10% 20%",
                                  borderRadius: isMobile() ? "" : "50%",
                                }}
                                onClick={(e) => showHistory(tl)}
                              >
                                <i className={`fa fa-history`} />
                              </button>
                            </div>
                            {tl.show_history ? (
                              <div>
                                <Timeline
                                  rate_list={tl.rate_list}
                                  enquiry={item}
                                  index={index}
                                />
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    );
                  })
                  : null}
              </div>
            ) : (
              <div style={{ borderRadius: "8px", border: "1px solid #e3e6f0", marginTop: "15px" }}>
                <table className="table table-hover mb-0" style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
                  <thead style={{ background: "#f8f9fc", color: "#5a5c69", fontSize: "12px", textTransform: "uppercase", letterSpacing: "0.5px", borderBottom: "2px solid #e3e6f0" }}>
                    <tr>
                      <th style={{ width: "5%", textAlign: "center" }}>Rank</th>
                      <th style={{ width: "25%", paddingLeft: "2%" }}>
                        Transporter Name
                      </th>
                      <th style={{ width: "12%", textAlign: "center" }}>
                        Quotation{" "}
                        {companySettingData?.default_currency?.default_currency
                          ?.symbol ?? <i className="fa fa-inr" />}
                        <i
                          className={"fa fa-info-circle"}
                          data-tip
                          data-for={"desc1"}
                          style={{ margin: "0 2%" }}
                        ></i>
                        <ReactTooltip
                          id="desc1"
                          place="top"
                          effect="solid"
                          scrollHide={true} delayHide={0}
                        >
                          <span>
                            <i className="fa fa-tag" /> - Negotiated Rate
                          </span>
                          <br />
                          <span>
                            <i
                              className="fa fa-dot-circle-o"
                              style={{ color: "black" }}
                            />{" "}
                            - No Regret Offer : Final Negotiated Rate by
                            Transporter{" "}
                          </span>
                          <br />
                          <span>
                            <i
                              className="fa fa-gavel"
                              style={{ color: "black" }}
                            />{" "}
                            - New Quote{" "}
                          </span>
                        </ReactTooltip>
                      </th>
                      <th style={{ width: "25%", paddingLeft: "7%" }}>
                        Bid Status
                        <i
                          className={"fa fa-info-circle"}
                          data-tip
                          data-for={"desc"}
                          style={{ margin: "0 2%" }}
                        ></i>
                        <ReactTooltip
                          id="desc"
                          place="top"
                          effect="solid"
                          scrollHide={true} delayHide={0}
                        >
                          <span>
                            <i className="fa fa-check" /> - Accepted
                          </span>
                          <br />
                          <span>
                            <i className="fa fa-times" style={{ color: "red" }} />{" "}
                            - Rejected
                          </span>
                          <br />
                          <span>
                            {/* <i className="fa fa-inr" />  */}
                            {companySettingData?.default_currency
                              ?.default_currency?.symbol ? (
                              <span
                                style={{ fontSize: "13px", fontWeight: "bold" }}
                              >
                                {
                                  companySettingData?.default_currency
                                    ?.default_currency?.symbol
                                }
                              </span>
                            ) : (
                              <i className="fa fa-inr" />
                            )}
                            - Negotiate
                          </span>
                          <br />
                          <span>
                            <i className="fa fa-history" /> - History
                          </span>
                          <br />
                        </ReactTooltip>
                      </th>
                      <th style={{ width: "15%", textAlign: "center" }}>
                        Timestamp
                      </th>
                      <th style={{ width: "10%", textAlign: "center" }}>
                        Status
                      </th>
                      {/* <th style={{ width: "15%", textAlign: "center" }}>POC Number</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {interestedlist && interestedlist.length > 0
                      ? interestedlist
                        .sort((a, b) => {
                          if (!a.rate && !b.rate) return 0;
                          if (!a.rate) return 1;
                          if (!b.rate) return -1;
                          return parseFloat(a.rate) - parseFloat(b.rate);
                        })
                        .map((tl, index) => {
                          const rank =
                            tl.rate && parseFloat(tl.rate) > 0
                              ? index + 1
                              : null;
                          const updateInfo = updatedRateList.find(
                            (u) => u.transporter_id === tl.transporter_id,
                          );
                          const hasNewUpdates =
                            updateInfo?.new_updates === true;
                          return (
                            <React.Fragment key={tl.transporter_id || index}>
                              <tr style={{ verticalAlign: 'middle' }}>
                                <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                  {rank !== null ? <span>{rank}</span> : null}
                                </td>
                                <td>
                                  {tl.transporter_name ? (
                                    <ProfileModal
                                      transporter_list={interestedlist}
                                      transporter_id={tl.transporter_id}
                                      transporter_name={tl.transporter_name}
                                      screenName={"LoRRI Adhoc"}
                                      moduleName={"My Enquiries"}
                                    />
                                  ) : (
                                    item?.benchmark_transporter_list?.map((val) => {
                                      if (
                                        val.transporter_id === tl.transporter_id
                                      ) {
                                        return (
                                          <ProfileModal
                                            transporter_list={interestedlist}
                                            transporter_id={tl.transporter_id}
                                            transporter_name={tl.transporter_name}
                                            screenName={"LoRRI Adhoc"}
                                            moduleName={"My Enquiries"}
                                          />
                                        );
                                      }
                                    })
                                  )}
                                  {agentSettings?.agent_enabled &&
                                    (() => {
                                      const negotiation = transporterNegotiations.find(
                                        (n) => n.transporter_id === tl.transporter_id
                                      );
                                      if (!negotiation) return null;
                                      return (
                                        <div
                                          style={{
                                            display: "flex",
                                            width: "fit-content",
                                            alignItems: "center",
                                            gap: "4px",
                                            margin: "4px auto 0",
                                            background: "#eef1f8",
                                            color: "#393185",
                                            fontSize: "10px",
                                            fontWeight: 700,
                                            padding: "2px 8px",
                                            borderRadius: "10px",
                                          }}
                                        >
                                          <i className="fa fa-refresh" style={{ fontSize: "9px" }} />
                                          Round {negotiation.current_round} of{" "}
                                          {agentSettings?.max_rounds_per_transporter}
                                        </div>
                                      );
                                    })()}
                                </td>
                                <td
                                  style={{
                                    maxWidth: "8vw",
                                    wordWrap: "break-word",
                                  }}
                                  data-tip
                                  data-for={
                                    (tl.quot_type === "counter_offer_quote" ||
                                      tl.quot_type ===
                                      "quote_after_rejection") &&
                                      tl.rate_list &&
                                      tl.rate_list.length > 0 &&
                                      tl.rate_list[tl.rate_list.length - 1]
                                        .bid_status !== BID_STATUS.ACCEPTED
                                      ? "negotiated-rate"
                                      : tl.rate_list &&
                                        tl.rate_list.length > 0 &&
                                        tl.rate_list[
                                          tl.rate_list.length - 1
                                        ].no_regret_offer === true
                                        ? "final-negotiated-rate"
                                        : null
                                  }
                                >
                                  <span style={{ marginRight: "6%" }}>
                                    {tl.rate ? Number(tl.rate).toLocaleString('en-IN') : tl.rate}
                                  </span>
                                  {(tl.quot_type === "counter_offer_quote" ||
                                    tl.quot_type ===
                                    "quote_after_rejection") &&
                                    tl.rate_list &&
                                    tl.rate_list.length > 0 &&
                                    tl.rate_list[tl.rate_list.length - 1]
                                      .bid_status !== BID_STATUS.ACCEPTED ? (
                                    <>
                                      <i
                                        className={`fa fa-tag`}
                                        style={{
                                          cursor: "pointer",
                                          color: "black",
                                        }}
                                        data-tip
                                        data-for={"negotiate-rate"}
                                      />
                                      <ReactTooltip
                                        id="negotiate-rate"
                                        place="bottom"
                                        effect="solid"
                                        scrollHide={true} delayHide={0}
                                      >
                                        Negotiated Rate
                                      </ReactTooltip>
                                    </>
                                  ) : null}
                                  {tl.rate_list &&
                                    tl.rate_list.length > 0 &&
                                    tl.rate_list[tl.rate_list.length - 1]
                                      .no_regret_offer === true ? (
                                    <>
                                      <i
                                        className="fa fa-dot-circle-o"
                                        style={{
                                          color: "black",
                                          cursor: "pointer",
                                        }}
                                        data-tip
                                        data-for={"final-negotiated-rate"}
                                        aria-hidden="true"
                                      ></i>
                                      <ReactTooltip
                                        id="final-negotiated-rate"
                                        place="bottom"
                                        effect="solid"
                                        scrollHide={true} delayHide={0}
                                      >
                                        Final Negotiated Rate by Transporter
                                      </ReactTooltip>
                                    </>
                                  ) : null}
                                  {hasNewUpdates &&
                                    hasNewUpdates === true && (
                                      <>
                                        <i
                                          className="fa fa-gavel"
                                          style={{
                                            color: "forestgreen",
                                            cursor: "pointer",
                                            fontSize: "14px",
                                          }}
                                          data-tip
                                          data-for={"new-quote"}
                                          aria-hidden="true"
                                        ></i>
                                        <ReactTooltip
                                          id="new-quote"
                                          place="bottom"
                                          effect="solid"
                                          scrollHide={true} delayHide={0}
                                        >
                                          New Quote
                                        </ReactTooltip>
                                      </>
                                    )}
                                </td>
                                <td>
                                  {tl.rate_list && tl.rate_list.length > 0 ? (
                                    <div
                                      className={`row`}
                                      style={{ margin: "0" }}
                                    >
                                      <div className={`col-md-9`}>
                                        <GetStatus
                                          transporter={tl}
                                          index={index}
                                          {...getStatusSharedProps}
                                        />
                                      </div>
                                      <div className={`col-md-3`}>
                                        <button
                                          className={`btn btn-sm btn-info`}
                                          style={{
                                            margin: "1% 5%",
                                            padding: "10% 20%",
                                            borderRadius: "50%",
                                          }}
                                          onClick={(e) => showHistory(tl)}
                                        >
                                          <i className={`fa fa-history`} />
                                        </button>
                                      </div>
                                    </div>
                                  ) : (
                                    "-"
                                  )}
                                </td>
                                <td>
                                  {tl.rate_submission_date
                                    ? NegotiateDateFormatter(
                                      tl.rate_submission_date,
                                    )
                                    : null}
                                </td>
                                <td>
                                  {(() => {
                                    if (showStatusColumn && agentSettings?.agent_enabled) {
                                      const liveStatus = transporterStatuses[tl.transporter_id];
                                      if (liveStatus?.status === "processing") {
                                        return (
                                          <span
                                            className={`${classes["summary-live-status-badge"]} ${classes["summary-live-status-processing"]}`}
                                          >
                                            <i className="fa fa-circle-o-notch fa-spin" />
                                            <span>Agent is evaluating counter offer</span>
                                          </span>
                                        );
                                      }
                                      if (liveStatus?.status === "no_counter") {
                                        return (
                                          <span
                                            className={`${classes["summary-live-status-badge"]} ${classes["summary-live-status-no-counter"]}`}
                                            title={liveStatus.reasoning || undefined}
                                          >
                                            <i className="fa fa-minus-circle" />
                                            <span>Agent decided not to counter</span>
                                          </span>
                                        );
                                      }
                                      if (liveStatus?.status === "failed") {
                                        return (
                                          <span
                                            className={`${classes["summary-live-status-badge"]} ${classes["summary-live-status-failed"]}`}
                                            title={liveStatus.reasoning || undefined}
                                          >
                                            <i className="fa fa-exclamation-triangle" />
                                            <span>Agent run failed</span>
                                          </span>
                                        );
                                      }
                                    }
                                    return tl.rate
                                      ? "Quoted"
                                      : tl.interest_data &&
                                        tl.interest_data.length > 0
                                        ? tl.interest_data[
                                          tl.interest_data.length - 1
                                        ].interest_status === "not_interested"
                                          ? "Not Interested"
                                          : tl.interest_data[
                                            tl.interest_data.length - 1
                                          ].interest_status === "Interested"
                                            ? "Interested"
                                            : tl.interest_data[
                                              tl.interest_data.length - 1
                                            ].interest_status ===
                                              "not_operating"
                                              ? "Do Not Operate"
                                              : "Interested"
                                        : "Interested";
                                  })()}
                                </td>
                              </tr>
                              {tl.show_history && (
                                <tr>
                                  <td
                                    colSpan="6"
                                    style={{ padding: "0", maxWidth: "0", overflow: "visible" }}
                                  >
                                    <div style={{ background: "#f8f9fc", borderBottom: "2px solid #393185", borderTop: "1px solid #e3e6f0", padding: "12px 16px" }}>
                                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                                        <div style={{ fontWeight: 'bold', color: '#393185', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                          <i className="fa fa-history" style={{ marginRight: '6px' }} />
                                          Timeline History
                                        </div>
                                        <button
                                          className="btn btn-sm btn-outline-secondary"
                                          onClick={() => showHistory(tl)}
                                          style={{ fontSize: '11px', fontWeight: 'bold', padding: '2px 8px' }}
                                        >
                                          <i className="fa fa-times" style={{ marginRight: '4px' }} /> Close
                                        </button>
                                      </div>
                                      <Timeline
                                        rate_list={tl.rate_list}
                                        enquiry={item}
                                        index={index}
                                      />
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </React.Fragment>
                          );
                        })
                      : null}
                  </tbody>
                </table>
              </div>
            )}
          </div>
          {recommendationCards.map(
            ({ transporter, negotiation, isL1, firstQuote, finalQuote, savingsAmount, savingsPercent }) => (
              <div
                key={transporter.transporter_id}
                style={{
                  marginTop: "16px",
                  border: "1px solid #b7ebc9",
                  borderRadius: "10px",
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    background: "#16a34a",
                    color: "#fff",
                    padding: "8px 16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    gap: "8px",
                  }}
                >
                  <span style={{ fontWeight: 700, fontSize: "13px" }}>
                    LoRRI Agent recommendation
                  </span>
                  {savingsPercent != null && (
                    <span
                      style={{
                        background: "rgba(255,255,255,0.2)",
                        borderRadius: "20px",
                        padding: "3px 12px",
                        fontSize: "11px",
                        fontWeight: 700,
                      }}
                    >
                      {savingsPercent.toFixed(0)}% below opening
                    </span>
                  )}
                </div>
                <div
                  style={{
                    padding: "16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    gap: "16px",
                    background: "#fff",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <div
                      style={{
                        width: "36px",
                        height: "36px",
                        borderRadius: "50%",
                        background: "#393185",
                        color: "#fff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: 700,
                        fontSize: "13px",
                        flexShrink: 0,
                      }}
                    >
                      {(transporter?.transporter_name || "?")
                        .trim()
                        .split(" ")
                        .filter(Boolean)
                        .slice(0, 2)
                        .map((w) => w.charAt(0).toUpperCase())
                        .join("")}
                    </div>
                    <div>
                      <div style={{ fontWeight: 700, color: "#393185", fontSize: "14px" }}>
                        {transporter?.transporter_name}
                      </div>
                      <div style={{ color: "#6b7280", fontSize: "12px" }}>
                        {isL1 ? "Lowest quote (L1)" : "Quoted transporter"}
                      </div>
                      <div style={{ color: "#6b7280", fontSize: "12px" }}>
                        down from ₹{Number(firstQuote || 0).toLocaleString("en-IN")} over{" "}
                        {negotiation?.current_round} round
                        {negotiation?.current_round === 1 ? "" : "s"}
                      </div>
                    </div>
                  </div>

                  <div style={{ display: "flex", gap: "24px", flexWrap: "wrap" }}>
                    <div
                      style={{
                        border: "1px solid #e4e7ec",
                        borderRadius: "8px",
                        padding: "8px 14px",
                        textAlign: "center",
                      }}
                    >
                      <div style={{ fontSize: "10px", fontWeight: 700, color: "#4A5568", letterSpacing: "0.3px" }}>
                        FINAL QUOTE
                      </div>
                      <div style={{ fontSize: "16px", fontWeight: 700, color: "#393185" }}>
                        ₹{Number(finalQuote || 0).toLocaleString("en-IN")}
                      </div>
                    </div>
                    <div
                      style={{
                        border: "1px solid #b7ebc9",
                        borderRadius: "8px",
                        padding: "8px 14px",
                        textAlign: "center",
                        background: "#eafaf0",
                      }}
                    >
                      <div style={{ fontSize: "10px", fontWeight: 700, color: "#15803d", letterSpacing: "0.3px" }}>
                        YOU SAVE
                      </div>
                      <div style={{ fontSize: "16px", fontWeight: 700, color: "#16a34a" }}>
                        ₹{Number(savingsAmount || 0).toLocaleString("en-IN")}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    padding: "12px 16px",
                    background: "#f9fafb",
                    borderTop: "1px solid #e4e7ec",
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px",
                    flexWrap: "wrap",
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-sm"
                    style={{
                      background: "#16a34a",
                      color: "#fff",
                      fontWeight: 600,
                      border: "none",
                      padding: "6px 16px",
                      cursor: isRestricted ? "not-allowed" : "pointer",
                      opacity: isRestricted ? 0.6 : 1,
                    }}
                    disabled={isRestricted}
                    onClick={() => acceptrejectHandler(transporter, BID_STATUS.ACCEPTED)}
                  >
                    <i className="fa fa-check" style={{ marginRight: "6px" }} />
                    Approve
                  </button>
                  <Modal
                    buttonLabel={
                      <>
                        <i className="fa fa-refresh" style={{ marginRight: "6px" }} />
                        Extend
                      </>
                    }
                    buttonClass="btn btn-sm"
                    style={{
                      border: "1px solid #393185",
                      color: "#393185",
                      fontWeight: 600,
                      background: "#fff",
                      padding: "6px 16px",
                      cursor: isRestricted ? "not-allowed" : "pointer",
                      opacity: isRestricted ? 0.6 : 1,
                    }}
                    disabled={isRestricted}
                    content={({ onClose }) => (
                      <ExtendRoundsModal
                        item={item}
                        agentSettings={agentSettings}
                        onClose={onClose}
                        company_id={company_id}
                        fetchSpotData={fetchSpotData}
                        currentFilterPayload={currentFilterPayload}
                        onExtended={fetchAgentSettings}
                      />
                    )}
                    title="Extend LoRRI Agent rounds"
                    id={`closebutton-extend-rounds-${transporter.transporter_id}`}
                    size="md"
                    screenName="LoRRI Spot"
                    moduleName="My Enquiries"
                    activityName={`Extend LoRRI Agent rounds clicked for ${item.lane_details?.origin?.location_name} to ${item.lane_details?.destination?.location_name}`}
                    backdrop={false}
                  />
                  <Modal
                    buttonLabel={
                      <>
                        <i className="fa fa-hand-paper-o" style={{ marginRight: "6px" }} />
                        Take over
                      </>
                    }
                    buttonClass="btn btn-sm"
                    style={{
                      border: "1px solid #cdd3de",
                      color: "#4A5568",
                      fontWeight: 600,
                      background: "#fff",
                      padding: "6px 16px",
                      cursor: isRestricted ? "not-allowed" : "pointer",
                      opacity: isRestricted ? 0.6 : 1,
                    }}
                    disabled={isRestricted}
                    content={({ onClose }) => (
                      <TurnOffLorriAgentModal
                        item={item}
                        onClose={onClose}
                        company_id={company_id}
                        fetchSpotData={fetchSpotData}
                        currentFilterPayload={currentFilterPayload}
                      />
                    )}
                    title="Turn off LoRRI Agent"
                    id={`closebutton-lorri-agent-off-summary-${transporter.transporter_id}`}
                    size="md"
                    screenName="LoRRI Spot"
                    moduleName="My Enquiries"
                    activityName={`Take over clicked for ${item.lane_details?.origin?.location_name} to ${item.lane_details?.destination?.location_name}`}
                    backdrop={false}
                  />
                </div>
              </div>
            )
          )}
        </>
      ) : (
        <>
          {agentSettings?.agent_enabled && (
            <div className={classes["summary-agent-banner"]}>
              <span className={classes["summary-agent-banner-label"]}>
                AGENT TARGET
              </span>
              <span className={classes["summary-agent-banner-value"]}>
                ₹{Number(agentSettings?.target_rate || 0).toLocaleString("en-IN")}
              </span>
            </div>
          )}
          <div style={{ textAlign: "center", padding: "24px 16px", color: "#858796" }}>
            <i className="fa fa-clock-o" style={{ fontSize: "20px", marginBottom: "8px", display: "block" }} />
            <span style={{ fontSize: "13px", fontWeight: 600 }}>Transporter quotes pending</span>
          </div>
        </>
      )}
    </>
  );
};

export default Summary;
